import get from "lodash/get";
import round from "lodash/round";
import { GetScore, Lifter, Meet } from "types";
import { toLbs } from "util/conversions";
import { getTotal } from "util/lifterHelper";
import { isKgMeet } from "util/meetHelper";
import { ageCoef } from "./age";

const schwartzCoefTable = {
  90: 1.2803,
  91: 1.2627,
  92: 1.2455,
  93: 1.2287,
  94: 1.2124,
  95: 1.1965,
  96: 1.1809,
  97: 1.1657,
  98: 1.1509,
  99: 1.1365,
  100: 1.1223,
  101: 1.1086,
  102: 1.0952,
  103: 1.0821,
  104: 1.0693,
  105: 1.0569,
  106: 1.0448,
  107: 1.0329,
  108: 1.0214,
  109: 1.0101,
  110: 0.9991,
  111: 0.9884,
  112: 0.9779,
  113: 0.9677,
  114: 0.9578,
  115: 0.9481,
  116: 0.9385,
  117: 0.9293,
  118: 0.9203,
  119: 0.9115,
  120: 0.9029,
  121: 0.8946,
  122: 0.8863,
  123: 0.8783,
  124: 0.8706,
  125: 0.863,
  126: 0.8556,
  127: 0.8483,
  128: 0.8412,
  129: 0.8343,
  130: 0.8276,
  131: 0.821,
  132: 0.8146,
  133: 0.8083,
  134: 0.8022,
  135: 0.7961,
  136: 0.7903,
  137: 0.7846,
  138: 0.779,
  139: 0.7735,
  140: 0.7682,
  141: 0.763,
  142: 0.7579,
  143: 0.7528,
  144: 0.7479,
  145: 0.7432,
  146: 0.7385,
  147: 0.7339,
  148: 0.7294,
  149: 0.725,
  150: 0.7207,
  151: 0.7165,
  152: 0.7124,
  153: 0.7083,
  154: 0.7044,
  155: 0.7004,
  156: 0.6967,
  157: 0.693,
  158: 0.6893,
  159: 0.6857,
  160: 0.6822,
  161: 0.6787,
  162: 0.6753,
  163: 0.672,
  164: 0.6688,
  165: 0.6656,
  166: 0.6624,
  167: 0.6593,
  168: 0.6563,
  169: 0.6533,
  170: 0.6504,
  171: 0.6475,
  172: 0.6447,
  173: 0.642,
  174: 0.6392,
  175: 0.6365,
  176: 0.6339,
  177: 0.6313,
  178: 0.6288,
  179: 0.6262,
  180: 0.6238,
  181: 0.6214,
  182: 0.619,
  183: 0.6167,
  184: 0.6144,
  185: 0.6121,
  186: 0.6099,
  187: 0.6077,
  188: 0.6056,
  189: 0.6036,
  190: 0.6014,
  191: 0.5994,
  192: 0.5878,
  193: 0.5954,
  194: 0.5935,
  195: 0.5916,
  196: 0.5897,
  197: 0.5879,
  198: 0.5861,
  199: 0.5843,
  200: 0.5826,
  201: 0.5809,
  202: 0.5792,
  203: 0.5776,
  204: 0.576,
  205: 0.5744,
  206: 0.5729,
  207: 0.5714,
  208: 0.57,
  209: 0.5685,
  210: 0.567,
  211: 0.5657,
  212: 0.5643,
  213: 0.563,
  214: 0.5617,
  215: 0.5604,
  216: 0.5592,
  217: 0.558,
  218: 0.5568,
  219: 0.5556,
  220: 0.5545,
  221: 0.5535,
  222: 0.5524,
  223: 0.5514,
  224: 0.5504,
  225: 0.5994,
  226: 0.5485,
  227: 0.5476,
  228: 0.5467,
  229: 0.5458,
  230: 0.5449,
  231: 0.5441,
  232: 0.5433,
  233: 0.5426,
  234: 0.5418,
  235: 0.5411,
  236: 0.5405,
  237: 0.5398,
  238: 0.5391,
  239: 0.5385,
  240: 0.5379,
  241: 0.5373,
  242: 0.5367,
  243: 0.5362,
  244: 0.5357,
  245: 0.5352,
  246: 0.5347,
  247: 0.5342,
  248: 0.5337,
  249: 0.5333,
  250: 0.5328,
  251: 0.5325,
  252: 0.532,
  253: 0.5316,
  254: 0.5312,
  255: 0.5308,
  256: 0.5304,
  257: 0.53,
  258: 0.5296,
  259: 0.5292,
  260: 0.5289,
  261: 0.5284,
  262: 0.5281,
  263: 0.5276,
  264: 0.5273,
  265: 0.5268,
  266: 0.5263,
  267: 0.5259,
  268: 0.5254,
  269: 0.5248,
  270: 0.5243,
  271: 0.5239,
  272: 0.5232,
  273: 0.5227,
  274: 0.522,
  275: 0.5214,
  276: 0.5208,
  277: 0.5203,
  278: 0.5197,
  279: 0.5192,
  280: 0.5186,
  281: 0.518,
  282: 0.5175,
  283: 0.5169,
  284: 0.5164,
  285: 0.5158,
  286: 0.5154,
  287: 0.5147,
  288: 0.5142,
  289: 0.5137,
  290: 0.5132,
  291: 0.5126,
  292: 0.5121,
  293: 0.5115,
  294: 0.5109,
  295: 0.5104,
  296: 0.5098,
  297: 0.5094,
  298: 0.5088,
  299: 0.5083,
  300: 0.5077,
  301: 0.5072,
  302: 0.5067,
  303: 0.5062,
  304: 0.5057,
  305: 0.5053,
  306: 0.5047,
  307: 0.5043,
  308: 0.5037,
  309: 0.5032,
  310: 0.5027,
  311: 0.5022,
  312: 0.5017,
  313: 0.5013,
  314: 0.5007,
  315: 0.5002,
  316: 0.4998,
  317: 0.4992,
  318: 0.4988,
  319: 0.4982,
  320: 0.4978,
  321: 0.4973,
  322: 0.4968,
  323: 0.4964,
  324: 0.4959,
  325: 0.4955,
  326: 0.495,
  327: 0.4946,
  328: 0.4941,
  329: 0.4937,
  330: 0.4932,
  331: 0.4928,
  332: 0.4924,
  333: 0.4919,
  334: 0.4913,
  335: 0.4909,
  336: 0.4905,
  337: 0.4901,
  338: 0.4896,
  339: 0.4891,
  340: 0.4887,
  341: 0.4883,
  342: 0.4878,
  343: 0.4874,
  344: 0.487,
  345: 0.4866,
  346: 0.4862,
  347: 0.4858,
  348: 0.4854,
  349: 0.485,
  350: 0.4845,
  351: 0.4841,
  352: 0.4837,
  353: 0.4833,
  354: 0.4829,
  355: 0.4825,
  356: 0.4821,
  357: 0.4817,
  358: 0.4813,
  359: 0.4809,
  360: 0.4805,
  361: 0.4801,
  362: 0.4796,
};

export const schwartzCoef = function (bodyWeight: number | null | undefined) {
  if (!bodyWeight) {
    return 1;
  }

  if (bodyWeight < 90) {
    return 1.2803;
  }

  if (bodyWeight > 362) {
    return 0.4796;
  }

  return get(schwartzCoefTable, round(bodyWeight), 1);
};

const maloneCoefTable = {
  90: 1.1756,
  91: 1.1645,
  92: 1.1557,
  93: 1.145,
  94: 1.1365,
  95: 1.1261,
  96: 1.118,
  97: 1.1079,
  98: 1.098,
  99: 1.0903,
  100: 1.0807,
  101: 1.0732,
  102: 1.0657,
  103: 1.0566,
  104: 1.0494,
  105: 1.0405,
  106: 1.0336,
  107: 1.025,
  108: 1.0165,
  109: 1.0098,
  110: 1.0016,
  111: 0.9952,
  112: 0.9872,
  113: 0.9809,
  114: 0.9731,
  115: 0.967,
  116: 0.9595,
  117: 0.9536,
  118: 0.9462,
  119: 0.939,
  120: 0.9333,
  121: 0.9263,
  122: 0.9208,
  123: 0.911,
  124: 0.9086,
  125: 0.9019,
  126: 0.898,
  127: 0.8902,
  128: 0.8851,
  129: 0.8788,
  130: 0.8738,
  131: 0.8676,
  132: 0.8628,
  133: 0.8568,
  134: 0.8508,
  135: 0.8462,
  136: 0.8101,
  137: 0.8358,
  138: 0.8302,
  139: 0.8257,
  140: 0.8202,
  141: 0.8159,
  142: 0.8105,
  143: 0.8052,
  144: 0.801,
  145: 0.7959,
  146: 0.7918,
  147: 0.7867,
  148: 0.7827,
  149: 0.7769,
  150: 0.7737,
  151: 0.7697,
  152: 0.7666,
  153: 0.7627,
  154: 0.7596,
  155: 0.7565,
  156: 0.752,
  157: 0.752,
  158: 0.7453,
  159: 0.7431,
  160: 0.7387,
  161: 0.7358,
  162: 0.7322,
  163: 0.7293,
  164: 0.7258,
  165: 0.723,
  166: 0.7196,
  167: 0.7168,
  168: 0.7134,
  169: 0.7107,
  170: 0.7074,
  171: 0.704,
  172: 0.7014,
  173: 0.6981,
  174: 0.6956,
  175: 0.6923,
  176: 0.6898,
  177: 0.6866,
  178: 0.6811,
  179: 0.681,
  180: 0.6786,
  181: 0.6755,
  182: 0.6731,
  183: 0.6701,
  184: 0.6671,
  185: 0.6618,
  186: 0.6604,
  187: 0.6595,
  188: 0.6566,
  189: 0.6543,
  190: 0.6521,
  191: 0.6492,
  192: 0.6464,
  193: 0.6442,
  194: 0.6415,
  195: 0.6387,
  196: 0.6366,
  197: 0.6339,
  198: 0.6317,
  199: 0.63,
  200: 0.6286,
  201: 0.6269,
  202: 0.6256,
  203: 0.6239,
  204: 0.6226,
  205: 0.6209,
  206: 0.6196,
  207: 0.618,
  208: 0.6167,
  209: 0.6151,
  210: 0.6134,
  211: 0.6122,
  212: 0.6109,
  213: 0.6093,
  214: 0.6077,
  215: 0.6064,
  216: 0.6049,
  217: 0.6036,
  218: 0.6021,
  219: 0.6008,
  220: 0.5993,
  221: 0.5981,
  222: 0.5965,
  223: 0.5953,
  224: 0.5938,
  225: 0.5926,
  226: 0.5911,
  227: 0.5896,
  228: 0.5884,
  229: 0.5869,
  230: 0.5858,
  231: 0.5843,
  232: 0.5831,
  233: 0.5817,
  234: 0.5805,
  235: 0.5791,
  236: 0.5779,
  237: 0.5765,
  238: 0.5754,
  239: 0.574,
  240: 0.5725,
  241: 0.5714,
  242: 0.57,
  243: 0.5693,
  244: 0.5686,
  245: 0.5681,
  246: 0.5671,
  247: 0.5669,
  248: 0.5662,
  249: 0.5556,
  250: 0.5649,
};

export const maloneCoef = function (bodyWeight: number | null | undefined) {
  if (!bodyWeight) {
    return 1;
  }

  if (bodyWeight < 90) {
    return 1.1756;
  }

  if (bodyWeight > 250) {
    return 0.5649;
  }

  return get(maloneCoefTable, round(bodyWeight), 1);
};

export const schwartzMaloneCoef = function (lifter: Lifter, meet: Meet) {
  let bodyWeight = lifter.bodyWeight;

  if (isKgMeet(meet)) {
    bodyWeight = toLbs(bodyWeight);
  }

  if (lifter.gender === "MALE") {
    return schwartzCoef(bodyWeight);
  } else if (lifter.gender === "FEMALE") {
    return maloneCoef(bodyWeight);
  }

  return 0;
};

export const getSchwartzMalonePoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  let total = getTotal({ lifter, division, meet, forecasted });
  return total * schwartzMaloneCoef(lifter, meet);
};

export const getSchwartzMaloneAndAgePoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  return (
    getSchwartzMalonePoints({ lifter, division, meet, forecasted }) *
    ageCoef(lifter, meet)
  );
};
